"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomizrClient = void 0;

var _cimpressCustomizr = require("cimpress-customizr");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const LOUDSPEAKER_RESOURCE_ID = 'loudspeaker';
const CUSTOMIZR_BASE_URL = 'https://customizr.at.cimpress.io';

class CustomizrClient {
  constructor() {
    _defineProperty(this, "loudspeakerSettings", void 0);

    _defineProperty(this, "custmizr", void 0);

    this.loudspeakerSettings = {};
    this.custmizr = new _cimpressCustomizr.CustomizrClient({
      resource: LOUDSPEAKER_RESOURCE_ID,
      timeout: 3000,
      baseUrl: CUSTOMIZR_BASE_URL,
      retryAttempts: 2,
      retryDelayInMs: 1000
    });
  }

  async getLastAcknowledgementTimestamps(accessToken, sessionId) {
    try {
      const data = await this.custmizr.getSettings(accessToken, undefined, sessionId);
      this.loudspeakerSettings = data;
    } catch (error) {
      console.warn(error.message);
      this.loudspeakerSettings = {};
    }

    const timestamps = {};

    if (!this.loudspeakerSettings) {
      this.loudspeakerSettings = {};
    }

    Object.keys(this.loudspeakerSettings).forEach(channelId => {
      timestamps[channelId] = this.loudspeakerSettings[channelId].lastAcknowledgementTimestamp;
    });
    return timestamps;
  }
  /**
   * Set the new "acknowledgement timestamp" for all viewed channels.
   */


  async acknowledgeAnnouncements(accessToken, channelIds, lastAcknowledgementTimestamp, sessionId) {
    const body = this.getLastAcknowledgementTimestamps(accessToken, sessionId);
    channelIds.forEach(channelId => {
      body[channelId] = {
        lastAcknowledgementTimestamp
      };
    });

    try {
      await this.custmizr.putSettings(accessToken, body, undefined, sessionId);
    } catch (error) {
      console.warn(error.message);
    }
  }

}

exports.CustomizrClient = CustomizrClient;